"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var queryString = _interopRequireWildcard(require("query-string"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var serviceProviderManagementGateway = {
  getGroupAgreements: function getGroupAgreements(serviceProviderId, groupType) {
    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _angieslistAppPlatform.httpClient.get("/gateway/service-provider-management/v1/service-provider/".concat(serviceProviderId, "/group-agreements?").concat(queryString.stringify({
                groupType: groupType
              })), {
                headers: {
                  'Content-Type': 'application/json',
                  'X-ANGI-CallerType': 'ServiceProvider',
                  'X-ANGI-CallerId': serviceProviderId
                }
              });

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response.status === 200 ? response.body : null);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  isAgreementSigned: function isAgreementSigned(serviceProviderId, groupType) {
    var _this = this;

    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var result, signed;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this.getGroupAgreements(serviceProviderId, groupType);

            case 3:
              result = _context2.sent;

              if (!(result && result.contracts)) {
                _context2.next = 7;
                break;
              }

              signed = result.contracts.every(function (contract) {
                return contract.signed;
              });
              return _context2.abrupt("return", signed);

            case 7:
              return _context2.abrupt("return", false);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", true);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }))();
  }
};
var _default = serviceProviderManagementGateway;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/store/actions/serviceProviderManagementGateway.js
// module id = 3585
// module chunks = 25